const extractTimestampFromUuidV7 = (uuid) => {
  if (!/^[0-9a-fA-F-]{36}$/.test(uuid)) {
    throw new Error("Invalid UUID format");
  }
  const cleanUuid = uuid.replace(/-/g, "");
  const timestampHex = cleanUuid.substring(0, 12);
  const timestampMillis = parseInt(timestampHex, 16);
  return new Date(timestampMillis);
};
export {
  extractTimestampFromUuidV7
};
//# sourceMappingURL=extractTimestampFromUuidV7.mjs.map
